import _IconBlackFridayTag from "@features/icon/IconBlackFridayTag";
import _IconHighSampleDispatchRate from "@features/icon/IconHighSampleDispatchRate";
import _IconActiveCreator from "@features/icon/IconActiveCreator";
import _IconQuickResponse from "@features/icon/IconQuickResponse";
import { AgeGroup, ContentPreferenceType, CreatorScoreType, Gender } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
export var FOLLOWERS_MAX_FILTER_NUMBER = 1e9;
export var FOLLOWERS_MIN_FILTER_NUMBER = 0;
export var OtherFilterKey = /*#__PURE__*/function (OtherFilterKey) {
  OtherFilterKey["IsQuicklyResponse"] = "isQuicklyResponse";
  OtherFilterKey["IsActiveCreator"] = "isActiveCreator";
  OtherFilterKey["IsHighSampleDispatchRate"] = "isHighSampleDispatchRate";
  OtherFilterKey["IsBlackFridayRecommend"] = "isBlackFridayRecommend";
  return OtherFilterKey;
}({});
export var DefaultCategory = {
  key: 'creator_marketplace_detail_trend_tab1',
  default: 'All'
};
export var OtherFilterMap = [{
  name: {
    key: 'affiliate_find_creator_label_response',
    default: 'Active Response'
  },
  desc: {
    key: 'affiliate_find_creator_list_filter_tooltip_response',
    default: 'Active response mean that creators are quicker to view and respond to messages.'
  },
  value: OtherFilterKey.IsQuicklyResponse,
  icon: _IconQuickResponse
}, {
  name: {
    key: 'affiliate_find_creator_label_active',
    default: 'Diligent posting'
  },
  desc: {
    key: 'affiliate_find_creator_list_filter_tooltip_active',
    default: 'Diligent posting means that the number of short videos or livestreams posted by the creators is higher.'
  },
  value: OtherFilterKey.IsActiveCreator,
  icon: _IconActiveCreator
}, {
  name: {
    key: 'affiliate_find_creator_label_dispatch',
    default: 'Timely compliance'
  },
  desc: {
    key: 'affiliate_find_creator_list_filter_tooltip_dispatch',
    default: "Timely compliance means that creators' sample fulfillment rate is well above average."
  },
  value: OtherFilterKey.IsHighSampleDispatchRate,
  icon: _IconHighSampleDispatchRate
}, {
  name: {
    key: 'affiliate_creator_connect_blackfriday_label',
    default: 'Black Friday'
  },
  desc: {
    key: 'affiliate_creator_connect_blackfriday_note',
    default: 'Black Friday Collaborated creator'
  },
  value: OtherFilterKey.IsBlackFridayRecommend,
  icon: _IconBlackFridayTag,
  iconStyle: {
    width: 60,
    height: 20,
    marginRight: 2
  }
}];
export var FollowersFilterConfig = {
  title: {
    key: 'creator_marketplace_follower_plural',
    default: 'Followers'
  },
  config: [{
    name: {
      key: 'creator_marketplace_detail_trend_tab1',
      default: 'All'
    }
  }, {
    name: {
      key: 'creator_marketplace_data_followers1_new',
      default: '1K - 5K'
    },
    value: [1000, 5000]
  }, {
    name: {
      key: 'creator_marketplace_data_followers2_new',
      default: '5K - 10K'
    },
    value: [5000, 10000]
  }, {
    name: {
      key: 'creator_marketplace_data_followers3_new',
      default: '10K - 50K'
    },
    value: [10000, 50000]
  }, {
    name: {
      key: 'creator_marketplace_data_followers4',
      default: '50K - 100K'
    },
    value: [50000, 100000]
  }, {
    name: {
      key: 'creator_marketplace_data_followers5',
      default: 'more than 100K'
    },
    value: [100000, FOLLOWERS_MAX_FILTER_NUMBER]
  }]
};
export var FollowerAgeFilterConfig = {
  title: {
    key: 'creator_marketplace_data_age',
    default: 'Follower Age'
  },
  desc: {
    key: 'creator_marketplace_data_age_bubble',
    default: 'Follower age: The age group that has the highest share of followers. For example, when 18-24 is selected, you will be shown the creators with the highest share of followers aged 18-24.'
  },
  config: [{
    name: {
      key: 'creator_marketplace_detail_trend_tab1',
      default: 'All'
    }
  }, {
    name: {
      key: 'affiliate_find_creator_affiliate_marketplace_follower_age_filtering_option1',
      default: '18 - 24'
    },
    value: AgeGroup.AGE_GROUP_18_24
  }, {
    name: {
      key: 'affiliate_find_creator_affiliate_marketplace_follower_age_filtering_option2',
      default: '25 - 34'
    },
    value: AgeGroup.AGE_GROUP_25_34
  }, {
    name: {
      key: 'affiliate_find_creator_affiliate_marketplace_follower_age_filtering_option3',
      default: '35 and above'
    },
    value: AgeGroup.AGE_GROUP_GT_34
  }]
};
export var CreatorScoreFilterConfig = {
  title: {
    key: 'affiliate_find_cretaor_list_creator_score_filter',
    default: 'Creator Score'
  },
  desc: {
    key: 'affiliate_find_cretaor_list_creator_score_filter_description',
    default: 'The creator score is based on a series of performance indicators including revenue, orders, and livestream and video views'
  },
  config: [{
    name: {
      key: 'creator_marketplace_detail_trend_tab1',
      default: 'All'
    }
  }, {
    name: {
      key: '',
      default: '5 - 4'
    },
    value: CreatorScoreType.ABOVE_40
  }, {
    name: {
      key: '',
      default: '4 - 3'
    },
    value: CreatorScoreType.AMONG_30_39
  }, {
    name: {
      key: '',
      default: '3 - 2'
    },
    value: CreatorScoreType.AMONG_20_29
  }, {
    name: {
      key: '',
      default: '2 - 1'
    },
    value: CreatorScoreType.AMONG_10_19
  }]
};
export var ContentTypeFilterConfig = {
  title: {
    key: 'affiliate_find_cretaor_list_content_type_filter',
    default: 'Content Type'
  },
  desc: {
    key: 'affiliate_find_cretaor_list_content_type_filter_description',
    default: "Creator's content tendency, which means creator has better performance in video or live"
  },
  config: [{
    name: {
      key: 'creator_marketplace_detail_trend_tab1',
      default: 'All'
    }
  }, {
    name: {
      key: 'affiliate_common_video',
      default: 'Video'
    },
    value: ContentPreferenceType.VIDEO
  }, {
    name: {
      key: 'affiliate_common_live',
      default: 'Live'
    },
    value: ContentPreferenceType.LIVE
  }]
};
export var FollowerGenderFilterConfig = {
  title: {
    key: 'creator_marketplace_data_gender',
    default: 'Follower Gender'
  },
  desc: {
    key: 'creator_marketplace_data_gender_bubble',
    default: 'Follower gender: The gender that has the highest share of followers. When male is selected, you will be shown the creators with the highest share of male followers.'
  },
  config: [{
    name: {
      key: 'creator_marketplace_detail_trend_tab1',
      default: 'All'
    }
  }, {
    name: {
      key: 'creator_marketplace_data_gender_f',
      default: 'Female'
    },
    value: Gender.GENDER_FEMALE
  }, {
    name: {
      key: 'creator_marketplace_data_gender_m',
      default: 'Male'
    },
    value: Gender.GENDER_MALE
  }]
};